import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "posArrow-up",
  "use": "posArrow-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"posArrow-up\"><defs><style>#posArrow-up .cls-1{fill:none}</style></defs><title>组 2760</title><g id=\"posArrow-up_图层_2\" data-name=\"图层 2\"><g id=\"posArrow-up_图层_1-2\" data-name=\"图层 1\"><g id=\"posArrow-up_组_2760\" data-name=\"组 2760\"><path id=\"posArrow-up_矩形_392\" data-name=\"矩形 392\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path id=\"posArrow-up_路径_1337\" data-name=\"路径 1337\" d=\"M12.67 3L20 20.52a.72.72 0 0 1-.4 1 .74.74 0 0 1-.6 0l-6.7-3.27a.72.72 0 0 0-.64 0L5 21.47a.74.74 0 0 1-1-.35.78.78 0 0 1 0-.6L11.31 3a.74.74 0 0 1 1-.38.76.76 0 0 1 .36.38z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/posArrow-up.svg
// module id = gyH+
// module chunks = 6